import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCrsOuiXutDvHFy9jic2uPDbmzSBef9qzI",
  authDomain: "fantasyforge-9715d.firebaseapp.com",
  projectId: "fantasyforge-9715d",
  storageBucket: "fantasyforge-9715d.appspot.com",
  messagingSenderId: "233450702792",
  appId: "1:233450702792:web:0a5a136e763e68353ca2fd",
  measurementId: "G-NVC29039Q7"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage }; 